import { ReactNode } from 'react'
import { cn } from '@/utils/cn'

interface FormFieldProps {
  label: string
  htmlFor?: string
  required?: boolean
  error?: string
  children: ReactNode
  className?: string
}

export function FormField({ 
  label, 
  htmlFor, 
  required, 
  error, 
  children, 
  className 
}: FormFieldProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <label 
        htmlFor={htmlFor} 
        className={cn('coach-label', required && 'after:content-["*"] after:text-danger-500 after:ml-1')}
      >
        {label}
      </label>
      {children}
      {error && (
        <p className="text-sm text-danger-600" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}